import React from "react";
import get from "lodash/get";
import { withTranslation } from "react-i18next";
import { STRIPE, US_STATES, AU_STATES } from "../constants";
import submit from "submit-form";
import BackArrowButton from "../parts/back-arrow-button";
import LoginWrapper from "./LoginWrapper";
import Select from "../parts/inputs/select";
import { RillContext } from "../rill/RillReact/share/base";

class View extends React.Component {
  constructor(props, ctx) {
    super(props, ctx);
    this.state = {
      token: null,
      billingInfo: {
        addressLine1: "",
        addressLine2: "",
        city: "",
        state: "",
        country: get(this.props.activeUser, "country", ""),
      },
    };
  }

  componentDidMount() {
    this.loadStripeCard(this.props.stripeKey);
  }

  elementsStyle() {
    let fontColor = "";
    let placeholderColor = "";
    const htmlTags = document.getElementsByTagName("html");

    Array.prototype.slice.call(htmlTags).forEach((tag) => {
      if (tag?.attributes?.["data-theme"]?.value === "light") {
        fontColor = "rgba(0, 0, 0, 0.85)";
        placeholderColor = "rgba(0, 0, 0, 0.3)";
      } else {
        fontColor = "rgba(255, 255, 255, 0.85)";
        placeholderColor = "rgba(255, 255, 255, 0.3)";
      }
    });

    var style = {
      base: {
        color: fontColor,
        lineHeight: "19px",
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: "antialiased",
        fontSize: window.matchMedia("(min-width: 2100px)").matches
          ? "22px"
          : window.matchMedia("(min-width: 1700px)").matches
          ? "18px"
          : "14px",
        fontWeight: 600,
        iconColor: "rgba(255, 255, 255, 0.7)",
        "::placeholder": {
          color: placeholderColor,
        },
      },
      invalid: {
        color: "rgba(255, 56, 82, 1)",
        iconColor: "rgba(255, 56, 82, 1)",
      },
    };

    return style;
  }

  stripeTokenHandler(token, tokenData) {
    // Insert the token ID into the form so it gets submitted to the server
    const form = document.getElementById("payment-form");
    const hiddenInput = document.createElement("input");
    hiddenInput.setAttribute("type", "hidden");
    hiddenInput.setAttribute("name", "stripeToken");
    hiddenInput.setAttribute("value", token.id);
    form.appendChild(hiddenInput);

    // Submit the form
    submit("/actions/billing/coach", {
      method: "POST",
      body: {
        source: tokenData,
        stripeToken: token.id,
      },
    });

    this.setState({ token: token });
  }

  loadStripeCard(stripeKey) {
    const stripe = Stripe(stripeKey);
    const elements = stripe.elements();

    // Create an instance of the card Element.
    const card = elements.create("card", { style: this.elementsStyle() });
    // Add an instance of the card Element into the `card-element` <div>.
    card.mount("#card-element");

    // Handle real-time validation errors from the card Element.
    card.addEventListener("change", (event) => {
      var displayError = document.getElementById("card-errors");
      if (event.error) {
        displayError.textContent = event.error.message;
      } else {
        displayError.textContent = "";
      }
    });

    // Handle form submission.
    const form = document.getElementById("payment-form");

    form.addEventListener("submit", (event) => {
      event.preventDefault();

      const { addressLine1, addressLine2, city, state, country } =
        this.state.billingInfo;

      const tokenData = {
        address_line1: addressLine1,
        address_line2: addressLine2,
        address_city: city,
        address_state: state,
        address_country: country,
      };

      stripe.createToken(card, tokenData).then((result) => {
        if (result.error) {
          // Inform the user if there was an error.
          var errorElement = document.getElementById("card-errors");
          errorElement.textContent = result.error.message;
        } else {
          // Send the token to your server.
          this.stripeTokenHandler(result.token, tokenData);
        }
      });
    });
  }

  renderCard() {
    return (
      <>
        <label className="only-show-mobile" htmlFor="cardNumber">
          {this.props.t("coachBilling.cardNumberLabel")}
        </label>

        <div id="card-element" />
        <p id="card-errors" role="alert" />
      </>
    );
  }

  renderBillingInformation(activeUser, countries, getCountryName) {
    const { billingInfo } = this.state;
    const { addressLine1, addressLine2, city, country, state } = billingInfo;
    const countryOpts = countries.map((country) => ({
      value: country,
      label: getCountryName(country),
    }));
    const usStates = US_STATES.map((state) => ({
      value: state.abbreviation,
      label: state.name,
    }));
    const auStates = AU_STATES.map((state) => ({
      value: state.abbreviation,
      label: state.name,
    }));

    return (
      <article>
        <label htmlFor="source[address_line1]">{this.props.t("coachBilling.billingAddress")}</label>
        <div className="mt-0!">
          <input
            name="source[address_line1]"
            type="text"
            placeholder={this.props.t("coachBilling.addressLine1")}
            required
            value={addressLine1}
            onChange={(e) =>
              this.setState({
                billingInfo: Object.assign(billingInfo, {
                  addressLine1: e.target.value,
                }),
              })
            }
            sz="large"
          />

          <input
            name="source[address_line2]"
            type="text"
            placeholder={this.props.t("coachBilling.addressLine2")}
            value={addressLine2}
            onChange={(e) =>
              this.setState({
                billingInfo: Object.assign(billingInfo, {
                  addressLine2: e.target.value,
                }),
              })
            }
            sz="large"
          />
        </div>

        <div>
          <div>
            <label htmlFor="source[address_city]">{this.props.t("coachBilling.cityLabel")}</label>
            <input
              name="source[address_city]"
              type="text"
              placeholder={this.props.t("coachBilling.cityLabel")}
              value={city}
              required
              onChange={(e) =>
                this.setState({
                  billingInfo: Object.assign(billingInfo, {
                    city: e.target.value,
                  }),
                })
              }
              sz="large"
            />
          </div>

          <div>
            <label htmlFor="source[address_country]">{this.props.t("coachBilling.countryLabel")}</label>
            <Select
              name="source[address_country]"
              value={country}
              options={countryOpts}
              onChange={(country) =>
                this.setState({
                  billingInfo: Object.assign(billingInfo, {
                    country,
                  }),
                })
              }
            />
          </div>

          {country === "CA" && (
            <div>
              <label htmlFor="source[address_state]">{this.props.t("coachBilling.provinceLabel")}</label>
              <Select
                name="source[address_state]"
                value={state}
                onChange={(state) =>
                  this.setState({
                    billingInfo: Object.assign(billingInfo, {
                      state,
                    }),
                  })
                }
                options={[
                  { value: "", label: "Province" },
                  { value: "AB", label: "Alberta" },
                  { value: "BC", label: "British Columbia" },
                  { value: "MB", label: "Manitoba" },
                  { value: "NB", label: "New Brunswick" },
                  { value: "NL", label: "Newfoundland and Labrador" },
                  { value: "NS", label: "Nova Scotia" },
                  { value: "ON", label: "Ontario" },
                  { value: "PE", label: "Prince Edward Island" },
                  { value: "QC", label: "Quebec" },
                  { value: "SK", label: "Saskatchewan" },
                  { value: "NT", label: "Northwest Territories" },
                  { value: "NU", label: "Nunavut" },
                  { value: "YT", label: "Yukon" },
                ]}
              />
            </div>
          )}

          {country === "US" && (
            <div>
              <label htmlFor="source[address_state]">{this.props.t("coachBilling.stateLabel")}</label>
              <Select
                name="source[address_state]"
                value={state}
                onChange={(state) =>
                  this.setState({
                    billingInfo: Object.assign(billingInfo, {
                      state,
                    }),
                  })
                }
                options={usStates}
              />
            </div>
          )}

          {country === "AU" && (
            <div>
              <label htmlFor="source[address_state]">{this.props.t("coachBilling.stateLabel")}</label>
              <Select
                name="source[address_state]"
                value={state}
                onChange={(state) =>
                  this.setState({
                    billingInfo: Object.assign(billingInfo, {
                      state,
                    }),
                  })
                }
                options={auStates}
              />
            </div>
          )}

          {["AU", "CA", "US"].indexOf(country) == -1 && (
            <div>
              <label htmlFor="source[address_state]">{this.props.t("coachBilling.stateLabel")}</label>
              <input
                name="source[address_state]"
                type="text"
                placeholder={this.props.t("coachBilling.stateLabel")}
                value={state}
                onChange={(e) =>
                  this.setState({
                    billingInfo: Object.assign(billingInfo, {
                      state: e.target.value,
                    }),
                  })
                }
                sz="large"
              />
            </div>
          )}
        </div>
      </article>
    );
  }

  render() {
    const { t, activeUser, countries, getCountryName, activeAthletesCount } =
      this.props;

    const handleReturnButton = () => {
      submit("logout", {
        method: "GET",
      });
    };

    return (
      <LoginWrapper
        mainClass="Billing"
        left={
          <form
            action="/actions/billing/coach"
            method="post"
            id="payment-form"
            className="billing"
          >
            <BackArrowButton
              onBack={(_) => handleReturnButton()}
              classNames="mobile-hidden"
            />

            <section className="mobile-hidden">
              <h2 className="clipped text-center">
                {t("coachBilling.trialEnded")}
              </h2>
              <p className="text-center mt-3">
                {t("coachBilling.activeAthletes", {
                  count: activeAthletesCount,
                })}
              </p>
            </section>

            <header className="only-show-mobile">
              <section>
                <BackArrowButton onBack={(_) => handleReturnButton()} />

                <h2 className="clipped text-center">
                  {t("coachBilling.trialEnded")}
                </h2>
              </section>
              <p className="text-center mt-3">
                {t("coachBilling.activeAthletes", {
                  count: activeAthletesCount,
                })}
              </p>
            </header>

            <section>
              {this.renderCard()}
              {this.renderBillingInformation(
                activeUser,
                countries,
                getCountryName
              )}
            </section>

            <footer>
              <button
                data-button-type="primary"
                sz="large"
                className="px-10"
                type="submit"
              >
                {t("coachBilling.upgradeNow")}
              </button>

              <div>
                <span>{t("coachBilling.noPayment")} </span>
                <a
                  data-button-type="outline"
                  role="button"
                  sz="large"
                  href="/feedback"
                >
                  {t("coachBilling.tellUsWhy")}
                </a>
              </div>
            </footer>
          </form>
        }
      />
    );
  }
}

View.contextType = RillContext;

const TranslatedView = withTranslation("auth")(View);

const CoachBillingWithTranslation = (app) => {
  app.get("/coach-billing", async ({ res, req, locals, load }) => {
    const { activeUser } = locals;
    if (!activeUser) {
      res.redirect("/login");
      return;
    }

    let stripeCustomer,
      errors = [];
    try {
      stripeCustomer = await load("stripeCustomer", activeUser._id);
    } catch (e) {
      errors.push(e);
    }

    const stripeKey = STRIPE.PUBLISHABLE_KEY;

    let activeAthletesCount = 0;
    if (activeUser.athletes) {
      activeAthletesCount = activeUser.athletes.filter(
        (ath) => ath.status.inactive === false
      ).length;
    }

    res.body = (
      <TranslatedView
        stripeKey={stripeKey}
        activeUser={activeUser}
        activeAthletesCount={activeAthletesCount}
        countries={locals.countries}
        getCountryName={locals.getCountryName}
      />
    );
  });
};

export default CoachBillingWithTranslation;
